import { NgModule } from '@angular/core';

import { TooltipAliasDirective } from './tooltip-alias.directive';
import { TooltipModule } from './tooltip.module';

@NgModule({
  declarations: [
    TooltipAliasDirective,
  ],
  imports: [
    TooltipModule,
  ],
  exports: [
    TooltipAliasDirective,
  ],
})
export class TooltipAliasModule {
}
